import type { Mission } from '../missions.ts'

export const nih: Mission = {
  id: "nih",
  name: "National Institutes of Health",
  short: "NIH",
  call: "Health",
  kind: "subagency",
  parent: "hhs",
  url: "https://www.nih.gov/",
  established: 1887,
  palette: {
    primary: "#20558a",
    secondary: "#616265",
    accent: "#bd2426",
  },
  colorSource: {
    kind: "site",
    url: "https://www.nih.gov/",
  },
  motif: "helix",
  mission: {
    text: "NIH’s mission is to seek fundamental knowledge about the nature and behavior of living systems and the application of that knowledge to enhance health, lengthen life, and reduce illness and disability.",
    url: "https://www.nih.gov/about-nih/mission-goals",
  },
  fact: {
    text: "NIH traces its roots to 1887, when a one-room laboratory was created within the Marine Hospital Service.",
    url: "https://www.nih.gov/about-nih/organization/history",
  },
  logo: {
    file: "public/logos/nih.svg",
    source: "https://commons.wikimedia.org/wiki/File:NIH_2013_logo_vertical.svg",
  },
  identifier: {
    about: "https://www.nih.gov/about-nih",
    accessibility: "https://www.nih.gov/accessibility",
    foia: "https://www.nih.gov/institutes-nih/nih-office-director/office-communications-public-liaison/freedom-information-act-office",
    noFear: "https://eeo.nih.gov/no-fear-act",
    oig: "https://oig.hhs.gov/",
    performance: "https://www.nih.gov/about-nih/nih-wide-strategic-plan",
    privacy: "https://www.nih.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/nih-clinical-center-aerial.jpg",
        small: "/media/nih-clinical-center-aerial-sm.jpg",
        alt: "Aerial view of the NIH Clinical Center, a large brick hospital complex surrounded by trees on the Bethesda campus.",
        title: "Aerial view of the NIH Clinical Center (Building 10), Bethesda, Maryland",
        creator: "National Institutes of Health",
        source: "https://commons.wikimedia.org/wiki/File:Aerial_view_of_the_Clinical_Center_(Building_10),_NIH_Campus,_Bethesda,_MD_(20384488641).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/nih-clinical-center-atrium.jpg",
        small: "/media/nih-clinical-center-atrium-sm.jpg",
        alt: "The bright, high-ceilinged atrium of the NIH Clinical Center with potted palms and a central welcome desk.",
        title: "NIH Clinical Center atrium",
        creator: "National Institutes of Health",
        source: "https://commons.wikimedia.org/wiki/File:NIH_Clinical_Center_Atrium_(28788875795).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
